/** Day status for monthly absent grid (columns 1 … last day of month). */
export const DAY_STATUS = {
  absent: "bg-orange-500 ring-1 ring-orange-600/40",
  present: "bg-emerald-400 ring-1 ring-emerald-500/30",
  half: "bg-indigo-400 ring-1 ring-indigo-500/30",
  leave: "bg-sky-300 ring-1 ring-sky-400/40",
  sun: "bg-slate-200",
  empty: "bg-slate-50",
  muted: "bg-slate-100 opacity-40",
};

export function getDaysInMonth(month) {
  const last = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  return Array.from({ length: last }, (_, i) => i + 1);
}

/**
 * @param {Date} month
 * @param {{ absentDates: string[], presentDates?: string[], halfDayDates?: string[], leaveDates?: string[], cutoffYmd?: string|null }} row
 */
export function buildDayCellsForRow(month, row, cutoffYmd = null) {
  const y = month.getFullYear();
  const m = month.getMonth();
  const last = new Date(y, m + 1, 0).getDate();
  const absent = new Set(row.absentDates || []);
  const present = new Set(row.presentDates || []);
  const half = new Set(row.halfDayDates || []);
  const leave = new Set(row.leaveDates || []);
  const cells = [];

  for (let d = 1; d <= last; d++) {
    const dt = new Date(y, m, d);
    const key = `${y}-${String(m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    const isSunday = dt.getDay() === 0;
    const afterCutoff = cutoffYmd && key > cutoffYmd;

    let status = "empty";
    if (afterCutoff) status = "muted";
    else if (isSunday) status = "sun";
    else if (absent.has(key)) status = "absent";
    else if (leave.has(key)) status = "leave";
    else if (half.has(key)) status = "half";
    else if (present.has(key)) status = "present";

    cells.push({ day: d, ymd: key, status });
  }
  return cells;
}

export function dayStatusLabel(status) {
  switch (status) {
    case "absent":
      return "Absent";
    case "present":
      return "Present";
    case "half":
      return "Half day";
    case "leave":
      return "Paid leave";
    case "sun":
      return "Sunday";
    case "muted":
      return "After cutoff";
    default:
      return "—";
  }
}

export function MonthAbsentCalendarLegend({ className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-[10px] text-slate-600 ${className}`}>
      <span className="inline-flex items-center gap-1">
        <span className={`h-3 w-3 rounded-sm ${DAY_STATUS.absent}`} />
        Absent
      </span>
      <span className="inline-flex items-center gap-1">
        <span className={`h-3 w-3 rounded-sm ${DAY_STATUS.present}`} />
        Present
      </span>
      <span className="inline-flex items-center gap-1">
        <span className={`h-3 w-3 rounded-sm ${DAY_STATUS.half}`} />
        Half day
      </span>
      <span className="inline-flex items-center gap-1">
        <span className={`h-3 w-3 rounded-sm ${DAY_STATUS.leave}`} />
        Paid leave
      </span>
      <span className="inline-flex items-center gap-1">
        <span className={`h-3 w-3 rounded-sm ${DAY_STATUS.sun}`} />
        Sunday
      </span>
    </div>
  );
}
